import React from 'react';
import { motion } from 'framer-motion';

const AsSeenOn = () => {
  const badges = [
    { name: "Business Insider", url: "https://media-manager-c.questera.ai/greta-media/22508bb601940b4e20f7d160303c50efd71c7583e6bf992668d180d798243f38c2166642d2b71e0a7892275161f0f512/images/aW1hZ2UvcG5n/ce31ad070f0304aebf89c7d20ea4ad5d.png" },
    { name: "Yahoo!", url: "https://media-manager-c.questera.ai/greta-media/22508bb601940b4e20f7d160303c50efd71c7583e6bf992668d180d798243f38c2166642d2b71e0a7892275161f0f512/images/aW1hZ2UvcG5n/04dfb754bd7ef8e2632ead4d51425845.png" },
    { name: "Benzinga", url: "https://media-manager-c.questera.ai/greta-media/22508bb601940b4e20f7d160303c50efd71c7583e6bf992668d180d798243f38c2166642d2b71e0a7892275161f0f512/images/aW1hZ2UvcG5n/22455314531a78bd82371a51c0c876cf.png" },
    { name: "Google News", url: "https://media-manager-c.questera.ai/greta-media/22508bb601940b4e20f7d160303c50efd71c7583e6bf992668d180d798243f38c2166642d2b71e0a7892275161f0f512/images/aW1hZ2UvcG5n/a116a6ca393e370b5ded3c10223543b3.png" },
    { name: "Digital Journal", url: "https://media-manager-c.questera.ai/greta-media/22508bb601940b4e20f7d160303c50efd71c7583e6bf992668d180d798243f38c2166642d2b71e0a7892275161f0f512/images/aW1hZ2UvcG5n/b638ef3f0ad2d7b992751683d269680f.png" },
    { name: "NEWSnet", url: "https://media-manager-c.questera.ai/greta-media/22508bb601940b4e20f7d160303c50efd71c7583e6bf992668d180d798243f38c2166642d2b71e0a7892275161f0f512/images/aW1hZ2UvcG5n/ec4456b70210f7b67c26e770318aba57.png" }
  ];

  return (
    <section className="py-12 md:py-20 border-y border-white/5 bg-[#070b14]">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-xs font-bold text-slate-500 uppercase tracking-[0.3em] mb-12">As Featured In</p>
        
        {/* Mobile: Grid / Desktop: Flex */}
        <div className="grid grid-cols-3 md:flex md:flex-row md:justify-center items-center gap-8 md:gap-16 opacity-40 grayscale hover:opacity-100 hover:grayscale-0 transition-all duration-500">
          {badges.map((badge, idx) => (
            <div key={idx} className="flex justify-center">
              <img 
                src={badge.url} 
                alt={badge.name} 
                className="h-4 sm:h-6 md:h-8 lg:h-10 w-auto object-contain" 
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AsSeenOn;